import { MessageCircle, ShoppingBag, Instagram, Music2, MapPin, Star, Link2 } from "lucide-react";
import { Seo } from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { BUSINESS, restaurantLd, breadcrumbLd } from "../data/business";

const CHANNELS = [
  { id: "whatsapp", icon: MessageCircle, title: "WhatsApp", desc: `Reservasi dan pertanyaan — ${BUSINESS.phoneDisplay}`, href: BUSINESS.links.whatsapp, cta: "Chat WhatsApp", primary: true },
  { id: "order", icon: ShoppingBag, title: "Pesan Online", desc: "Pesan antar langsung dari kanal pemesanan resmi kami.", href: BUSINESS.links.orderOnline, cta: "Pesan Sekarang", primary: true },
  { id: "instagram", icon: Instagram, title: "Instagram", desc: "@baksotujuhpemuda — kabar dan menu terbaru.", href: BUSINESS.links.instagram, cta: "Ikuti Kami" },
  { id: "tiktok", icon: Music2, title: "TikTok", desc: "@baksotujuhpemuda — keseruan dapur terbuka kami.", href: BUSINESS.links.tiktok, cta: "Tonton Video" },
  { id: "maps", icon: MapPin, title: "Google Maps", desc: BUSINESS.address.full, href: BUSINESS.links.maps, cta: "Buka Peta" },
  { id: "review", icon: Star, title: "Ulasan Google", desc: "Sudah mampir? Ceritakan pengalaman Anda.", href: BUSINESS.links.googleReview, cta: "Tulis Ulasan" },
];

export default function KontakPage() {
  return (
    <>
      <Seo
        title="Kontak Bakso Tujuh Pemuda — WhatsApp, Reservasi & Pesan Online"
        description="Hubungi Bakso Tujuh Pemuda Bogor: reservasi lewat WhatsApp, pesan antar online, Instagram, TikTok, dan alamat di Jl. Pengadilan No. 51, Bogor Tengah."
        path="/kontak/"
        jsonLd={[restaurantLd, breadcrumbLd([{ name: "Beranda", path: "/" }, { name: "Kontak", path: "/kontak/" }])]}
      />
      <PageHeader
        crumb="Kontak"
        eyebrow="Kami siap menyambut"
        lines={[<>Kontak <span className="italic font-semibold text-terracotta">Bakso Tujuh Pemuda</span></>]}
      />
      <section className="py-16 sm:py-24" data-testid="kontak-page">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CHANNELS.map((c, i) => (
              <Reveal key={c.id} delay={i * 0.06}>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`kontak-${c.id}-card`}
                  className={`group flex flex-col h-full rounded-3xl border p-6 transition-all duration-300 hover:-translate-y-1 ${
                    c.primary
                      ? "bg-terracotta text-cream border-terracotta hover:shadow-[0_20px_50px_-20px_rgba(200,59,43,0.6)]"
                      : "bg-white border-line hover:border-terracotta/50 hover:shadow-lg"
                  }`}
                >
                  <c.icon size={28} className={c.primary ? "text-amberbrand" : "text-terracotta"} />
                  <h2 className="mt-4 font-display font-black text-xl">{c.title}</h2>
                  <p className={`mt-2 text-sm leading-relaxed flex-1 ${c.primary ? "text-cream/80" : "text-ink-soft"}`}>{c.desc}</p>
                  <span className={`mt-5 inline-flex items-center gap-2 font-bold text-sm ${c.primary ? "text-amberbrand" : "text-terracotta"}`}>
                    {c.cta}
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="mt-12 rounded-3xl bg-tint border border-line p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-5 justify-between" data-testid="kontak-linktree-banner">
              <div>
                <h2 className="font-display font-black text-xl">Semua tautan resmi kami</h2>
                <p className="mt-1 text-sm text-ink-soft">Satu halaman berisi seluruh kanal resmi Bakso Tujuh Pemuda.</p>
              </div>
              <a
                href={BUSINESS.links.linktree}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="kontak-linktree-button"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-leaf text-cream font-bold hover:bg-leaf-deep transition-colors duration-300 shrink-0"
              >
                <Link2 size={18} /> Buka Linktree
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
